import PropTypes from 'prop-types';
import React from 'react';
import VisuallyHidden from '@mc/components/VisuallyHidden';

const LiveMessageBlock = ({ message, 'aria-live': ariaLive }) => {
  return (
    <VisuallyHidden
      role={ariaLive === 'polite' ? 'status' : 'alert'}
      aria-live={ariaLive}
      aria-relevant="text"
      aria-atomic="true"
    >
      {message}
    </VisuallyHidden>
  );
};

LiveMessageBlock.propTypes = {
  message: PropTypes.string.isRequired,
  'aria-live': PropTypes.string.isRequired,
};

export default LiveMessageBlock;
